import axios, { type AxiosInstance } from 'axios'
import { auth } from './firebase'
import { env } from './env'
import { demoAdapter, isDemo } from './demo'

// getIdToken() refreshes an expired token; v1 read user.accessToken directly,
// which went stale after an hour on an open tab.
function withAuth(instance: AxiosInstance) {
  instance.interceptors.request.use(async (config) => {
    const user = auth.currentUser
    if (user) config.headers.Authorization = `Bearer ${await user.getIdToken()}`
    return config
  })
  return instance
}

/** Main API: auth, teams, notifications, settings. */
export const api = withAuth(axios.create({ baseURL: `${env.apiBaseUrl}/api/v1` }))

/** Unauthenticated calls on the main API host (password reset). */
export const publicApi = axios.create({ baseURL: env.apiBaseUrl })

/**
 * Customers API: companies and dashboard stats. A team can run its own
 * instance (team.CustomersApiUrl), so the base URL is set once the current
 * team loads — see CurrentTeamProvider.
 */
export const customersApi = withAuth(axios.create({ baseURL: `${env.customersApiBaseUrl}/api/v1` }))

export function setCustomersApiBaseUrl(url: string | null | undefined) {
  customersApi.defaults.baseURL = `${url || env.customersApiBaseUrl}/api/v1`
}

// dev-only: /__demo swaps the network for fixtures (see lib/demo.ts)
if (isDemo()) for (const i of [api, publicApi, customersApi]) i.defaults.adapter = demoAdapter
